import React from "react";
import ShortHeaderComponent from "../hyvid-awards/components/ShortHeaderComponent";
import { ArrowLeft, UserCheck } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import ApprovalList from "./components/ApprovalList";

const ApprovalRewards = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navFromQuickAccess = location.state?.fromQuickAccess;
    return (
        <div>
            {navFromQuickAccess && (
                <button
                    onClick={() => navigate("/console/dashboard")}
                    className="flex items-center border rounded-xl px-2 py-1 gap-2 dark:text-white mb-4"
                >
                    <ArrowLeft className="w-4 h-4 dark:text-white"/>
                    Back to Dashboard
                </button>
            )}
            <div className="flex flex-col gap-6">
            
                <ShortHeaderComponent
                    icon="UserCheck"
                    title={"Approve Rewards"}
                    description={"Review and approve reward nominations to recognize outstanding team members"}
                />
                <ApprovalList />
            </div>
        </div>
    );
};

export default ApprovalRewards;